/**
 * Nach dem Namen filtern — die Regel hinter den Suchfeldern über den Werkzeugtabellen.
 *
 * Vier Tabellen (Werkzeugsätze, Wissensbasen, Prompt-Werkzeuge, Workflows) stellen dieselbe Frage,
 * also steht die Antwort einmal hier. Gesucht wird als **Teilzeichenkette** ohne Rücksicht auf
 * Groß- und Kleinschreibung: Wer „ausschreib" tippt, findet „Ausschreibungsklassifikation" — eine
 * Regel, die sich aussprechen lässt, im Gegensatz zu einer Ähnlichkeitsbewertung.
 *
 * Rein: keine Oberfläche, keine Hooks.
 */

/** Trifft dieser Name das Gesuchte? Ohne Eingabe trifft alles. */
export const passtZumNamen = (name: unknown, filter: string): boolean => {
  const gesucht = String(filter ?? '')
    .trim()
    .toLowerCase();
  if (!gesucht) return true;
  return String(name ?? '')
    .toLowerCase()
    .includes(gesucht);
};

/**
 * Die Einträge, deren Name das Gesuchte enthält.
 *
 * Ohne Eingabe kommt die Liste **unverändert** zurück — dieselbe Referenz, damit ein `useMemo`
 * darüber nichts neu berechnet und die Tabelle nicht ohne Grund neu rendert.
 */
export const nachNamenFiltern = <T>(
  liste: readonly T[] | undefined | null,
  filter: string,
  namenLesen: (eintrag: T) => unknown = (eintrag: any) => eintrag?.name
): T[] => {
  const eintraege = (liste ?? []) as T[];
  if (!String(filter ?? '').trim()) return eintraege as T[];
  return eintraege.filter(eintrag => passtZumNamen(namenLesen(eintrag), filter));
};
